import axios from 'axios'
import globalConfig from '../config/globle.config'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import modal from 'ant-design-vue/es/modal'
import store from '../router'
import { resolve } from 'any-promise'

const error = (e) => {
  if (e && e.response && e.response.status == 401) {
    if (e.config.redirectLogin) {
      store.push('login?ret='+encodeURIComponent(location.href)) //登陆后返回目标地址
    } else {
      notification.error({
        message: '身份验证失败',
        description: '服务器无法获取您的身份，请重新登录后再尝试操作。',
      })
    }
    
    return Promise.reject(e)
  }
  notification.error({
    message: '错误',
    description: '服务器请求异常:(HTTP:'+e.response.status+','+e.message+')',
  })
  console.log(e.response);
  return Promise.reject(e.response)
}

//创造一个axios的实例
const service = axios.create({
  baseURL: globalConfig.rootUrl,
  timeout: 60 * 3 * 1000,
})

service.interceptors.request.use((config) => {
  return config
})

service.interceptors.response.use((res) => {
  var contentType = res.headers['content-type'];
  if (contentType && !contentType.includes("json")) {
    //文件类型的响应，非JSON Api 响应
    return Promise.resolve(res)
  }
  if (contentType && contentType.includes("json") && res.data && res.data.code != 0) {
    switch (res.data.code) {
      case 401:
        if (e.config.redirectLogin) {
          store.push('login')
        }
        return Promise.reject(res.data)
      case -1:
        notification.error({
          message: '错误',
          description: '异常:' + res.data.msg,
        })
        return Promise.reject(res.data)
      default:
        if (res.config.showErrorNotify) {
          (res.data.code != 2168 && res.data.code != 2169)? message.error(res.data.msg) : ''
        }
        return Promise.reject(res.data)
    }
  }
  return Promise.resolve(res.data)
}, error)

export default service
